import Heading from 'components/common/Heading';
import Text from 'components/common/Text';

import MealCard from './MealCard';
import TempoHeaderUnderline from './TempoHeaderUnderline';

const MealCardContainer = ({
  selectedMeals,
  meals,
  shipWeek,
  removeServing,
  removeMeal,
  addServing,
  disabled = false,
}) => (
  <>
    <div className="w-min">
      <Text className="text text-nowrap text-left text-charcoal-90">Menu for the week of</Text>
      <Heading className="text-nowrap">{shipWeek}</Heading>
      <TempoHeaderUnderline className="w-min" />
    </div>
    <Text className="text pb-4 pt-2 text-left text-black-100">
      Single-serving meals that are ready in 2 minutes!
    </Text>
    <div className="grid grid-cols-1 bp2:grid-cols-2 bp3:grid-cols-3">
      {meals.map(meal => (
        <MealCard
          key={meal.id}
          meal={meal}
          removeMeal={removeMeal}
          removeServing={removeServing}
          addServing={addServing}
          servings={selectedMeals.find(m => m.id === meal.id)?.servings || 0}
          disabled={disabled}
        />
      ))}
    </div>
  </>
);

MealCardContainer.propTypes = {
  meals: PropTypes.array.isRequired,
  selectedMeals: PropTypes.array.isRequired,
  shipWeek: PropTypes.string.isRequired,
  removeMeal: PropTypes.func.isRequired,
  removeServing: PropTypes.func.isRequired,
  addServing: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default MealCardContainer;
